import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
export const getProductRelationItems = ({ productVariants, items, }) => {
    const fromProductVariants = (productVariants ?? []).map(({ sku, name, images, components, product }) => {
        // With the given data, we can't be sure if the product is a book (ISBN in SKU) or a non-book (EAN field),
        // therefore we need to first get the EAN from the components, if that fails, we use the SKU as ISBN
        const isbnean = getEanFromComponents(components) ?? sku;
        return {
            sku,
            name,
            image: images?.find(({ url }) => url)?.url ?? undefined,
            isbnean,
            shapeIdentifier: product?.shape?.identifier,
        };
    });
    const fromProductItems = (items ?? [])
        .flatMap((item) => {
        if (item.__typename !== "Product" || !item.defaultVariant?.sku) {
            return [];
        }
        const { defaultVariant } = item;
        const isbnean = getEanFromComponents(defaultVariant.components) ?? defaultVariant.sku;
        return {
            sku: defaultVariant.sku,
            name: defaultVariant.name,
            image: defaultVariant.images?.find(({ url }) => url)?.url ?? undefined,
            isbnean,
            shapeIdentifier: item.shape?.identifier,
        };
    })
        .filter((gift) => Boolean(gift.sku));
    const merged = [...fromProductVariants, ...fromProductItems];
    return merged.filter((gift, index, list) => list.findIndex((candidate) => candidate.sku === gift.sku) === index);
};
export function getEanFromComponents(components) {
    const eanComponent = components?.find((component) => component.componentId ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.NOT_BOOK.VARIANT.EAN);
    if (eanComponent?.content?.__typename === "NumericContent") {
        return eanComponent.content.number?.toString();
    }
}
